import Big from "big.js";
import { TicketExtended } from "./TypeExtensions";
import TimeCalculator from "../sharedCode/TimeCalculator";
import { Aircraft } from "../sharedCode/avroGraphql";
import { FUEL_LINE_ITEM_TYPES } from "../sharedCode/metadata";

// Taken from the same page as the fractional hour by minutes table
export const BELL_212 = "BELL 212";

// NB - we look these types up with a contains, so BELL 206 will match any of the three models in RPS
export const acType = ["BELL 206", "AS350BA", "AS350B2", "AS350B3", BELL_212, "EC135"];
export const fuelRate = [114, 180, 190, 200, 410, 280];

interface TicketFuel {
    requiredFuel: Big;
    allocatedFuel: Big;
    fuelToAllocate: Big;
}

export default class FuelCalculator {
    static Calculate(ticket: TicketExtended, aircraft: Aircraft | undefined): TicketFuel {
        const requiredFuel = this.CalculateRequiredFuel(ticket, aircraft);
        const allocatedFuel = this.CalculateAllocatedFuel(ticket);
        const fuelToAllocate = requiredFuel.minus(allocatedFuel);

        return { requiredFuel, allocatedFuel, fuelToAllocate };
    }

    static CalculateRequiredFuel(ticket: TicketExtended, aircraft: Aircraft | undefined): Big {
        let requiredFuel = new Big(0);

        if (ticket) {
            const flightTime = TimeCalculator.getTotalFlightTime(ticket);
            const rateIndex = acType.findIndex((t) => (aircraft?.AircraftType.name ?? "MISSING A/C TYPE").includes(t));
            const burnRate = rateIndex >= 0 ? fuelRate[rateIndex] : 1; // NB if fuel == flight time it means the burn rate is 1 because the a/c type is unknown

            requiredFuel = flightTime.times(burnRate);
        }

        return requiredFuel;
    }

    static CalculateAllocatedFuel(ticket: TicketExtended): Big {
        let allocatedFuel = new Big(0);

        const fuelLineItems = ticket.LineItems?.filter((r) => FUEL_LINE_ITEM_TYPES.findIndex((id) => id === r?.line_item_type_id) >= 0);

        if (fuelLineItems) {
            for (let i = 0; i < fuelLineItems.length; i++) {
                allocatedFuel = allocatedFuel.add(fuelLineItems[i]?.amount ?? 0);
            }
        }

        return allocatedFuel;
    }
}
